module.exports = __webpack_public_path__ + "static/media/cdb17.70e65292.png";